import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../../Button';
import CustomControl from '../../../../../../../CustomControl';
import Spinner from '../../../../../../../Spinner';
import {
  getGroupDisplayName,
  getGroupSmartMatchingCopy,
} from '../../../../../../../../../util/print-asset-groups';
import { getPrintAssetDisplayImageUrl } from '../../../../../../../../../util/print-assets';

const propTypes = {
  group: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    members: PropTypes.object,
  }).isRequired,
  currentAssetImageId: PropTypes.string,
  smartEnabled: PropTypes.bool,
  onSmartToggle: PropTypes.func.isRequired,
  onAssetSelect: PropTypes.func.isRequired,
};

// Sticky expansion of a print asset group in the Waldo library: toggle Smart
// Color Matching for the group or pick one of its variants. Shows a loading
// state until the variant images are in.
const CardDesignerAssetGroupPanel = ({
  group,
  currentAssetImageId,
  smartEnabled = false,
  onSmartToggle,
  onAssetSelect,
}) => {
  const [loadedMemberIds, setLoadedMemberIds] = useState({});

  useEffect(() => {
    setLoadedMemberIds({});
  }, [group.id]);

  const members = group.members?.records ?? [];
  const loading = members.some(member => !loadedMemberIds[member.id]);

  const onMemberImageSettled = memberId =>
    setLoadedMemberIds(previous => ({ ...previous, [memberId]: true }));

  return (
    <div className="card-designer-asset-group-panel">
      <div className="card-designer-asset-group-panel-header">
        <div className="d-flex align-items-center">
          <span className="text-dark text-extra-bold">
            {getGroupDisplayName(group)}{' '}
          </span>
          {loading && <Spinner size="xs" className="ml-1" />}
        </div>
        <hr className="my-1 w-100" />
        <CustomControl
          type="checkbox"
          id="card-designer-asset-group-panel-smart"
          checked={smartEnabled}
          onChange={() => onSmartToggle(group, !smartEnabled)}
          label="Smart Color Matching"
        />
        <p className="text-xs text-light mb-0">
          {getGroupSmartMatchingCopy({ group, smartEnabled })}
        </p>
      </div>
      <div
        className={classNames({
          'card-designer-asset-group-panel-assets': true,
          loading,
        })}
      >
        {members.map(member => (
          <Button
            key={member.id}
            btnStyle="reset"
            aria-label={member.print_asset.name}
            className={classNames({
              'card-designer-asset-group-panel-asset': true,
              selected:
                member.print_asset.asset_image?.id === currentAssetImageId,
            })}
            onClick={() => onAssetSelect(member.print_asset)}
          >
            <img
              src={getPrintAssetDisplayImageUrl(member.print_asset)}
              alt=""
              onLoad={() => onMemberImageSettled(member.id)}
              onError={() => onMemberImageSettled(member.id)}
            />
          </Button>
        ))}
      </div>
    </div>
  );
};

CardDesignerAssetGroupPanel.propTypes = propTypes;

export default CardDesignerAssetGroupPanel;
